/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export default interface Button {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  pdfLinkInDam ? : Asset;
  showCtaAsPdf ? : boolean;
  ctaText ? : string;
  ctaTextColor ? : number;
  buttonColor ? : number;
  borderColor ? : number;
  buttonSize: string;
  buttonCorner: string;
  metadata ? : any;
}

export const Props = {
  switchable: Object as() => switchableStruct,
  linkTargetMode: String,
  title: String,
  pdfLinkInDam: Object as() => Asset,
  showCtaAsPdf: Boolean,
  ctaText: String,
  ctaTextColor: Number,
  buttonColor: Number,
  borderColor: Number,
  buttonSize: String,
  buttonCorner: String,
  metadata: Object,
}

export const WrapperProps = {
  switchable: Object as() => switchableStruct,
  linkTargetMode: String,
  title: String,
  pdfLinkInDam: Object as() => Asset,
  showCtaAsPdf: Boolean,
  ctaText: String,
  ctaTextColor: Number,
  buttonColor: Number,
  borderColor: Number,
  buttonSize: String,
  buttonCorner: String,
  metadata: Object,
}

export class ButtonBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class ButtonInstance implements Button {
      switchable ? : switchableStruct;
      linkTargetMode ? : string;
      title ? : string;
      pdfLinkInDam ? : Asset;
      showCtaAsPdf ? : boolean;
      ctaText ? : string;
      ctaTextColor ? : number;
      buttonColor ? : number;
      borderColor ? : number;
      buttonSize: string;
      buttonCorner: string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.switchable) {
          if (typeof this.switchable.download === 'object') {
            this.switchable.download = {
              ...this.switchable.download,
              link: this.switchable.download['@link'],
              name: this.switchable.download['@name'],
              path: this.switchable.download['@path'],
            };
          } else {
            this.switchable.download = null as any;
          }
        }
        if (typeof this.pdfLinkInDam === 'object') {
          this.pdfLinkInDam = {
            ...this.pdfLinkInDam,
            link: this.pdfLinkInDam['@link'],
            name: this.pdfLinkInDam['@name'],
            path: this.pdfLinkInDam['@path'],
          };
        } else {
          this.pdfLinkInDam = null as any;
        }
      }
    }
    return new ButtonInstance(props);
  }
}
